import OffersRoutes from "./Offers.routes";
import { get, post, put, deleted } from "../../index";

const OffersServices = {
  getAllOffers: async (page, limit) => {
    const result = await get(OffersRoutes.getAllOffers + `?page=${page}&limit=${limit}`);
    return result;
  },

  createOffer: async (obj) => {
    const result = await post(OffersRoutes.createOffer, obj);
    return result;
  },

  updateOffer: async (id, obj) => {
    const result = await put(OffersRoutes.updateOffer + `/${id}`, obj);
    return result;
  },

  deleteOffer: async (id) => {
    const result = await deleted(OffersRoutes.deleteOffer + `/${id}`);
    return result;
  },
}

export default OffersServices;